import { createSlice } from "@reduxjs/toolkit";
import { getThumbnailURL } from "../actions/records.action";

const initialState = {
  isLoading: null,
  thumbnails: null,
};

const thumbnailsSlice = createSlice({
  name: "thumbnail",
  initialState,
  reducers: {
    resetThumbnail: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getThumbnailURL.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getThumbnailURL.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      if(payload?.data?.data) {
        const { data } = payload;
        state.thumbnails = {
          ...state.thumbnails,
          ...data.data,
        };
      }
    });
    builder.addCase(getThumbnailURL.rejected, (state) => {
      state.isLoading = false;
      state.records = null;
    });
  },
});

export const thumbnailSelector = (state) => state.thumbnail?.thumbnails || {};
export default thumbnailsSlice.reducer;
export const { resetThumbnail } = thumbnailsSlice.actions;
